import bracketAttachmentDefaultOptions from './defaultOptions';
import BracketAttachmentObject from './bracket-attachment.object';

export {
  BracketAttachmentObject,
  bracketAttachmentDefaultOptions
};



// WEBPACK FOOTER //
// ./src/object-view/generators/bracket-attachment/index.js